import { render, staticRenderFns } from "./DispensaryDetail.vue?vue&type=template&id=9ca21006&scoped=true&"
import script from "./DispensaryDetail.vue?vue&type=script&lang=js&"
export * from "./DispensaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./DispensaryDetail.vue?vue&type=style&index=0&id=9ca21006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca21006",
  null
  
)

export default component.exports